<template>
	<div class="wrapper info">
		<div class="content">
			<div class="topbar">
				<div class="logo">
					<router-link to="/profile">
						<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" class="logo" />
					</router-link>
				</div>
			</div>
			<h2>{{ t('txt_infos') }}</h2>
			<div v-if="infoData" class="menu-list">
				<div v-for="(content,index) in infoData" :key="content.id" class="contentitem">
					<details v-if="content.parent" class="padding" :open="isOpen[index]">
						<summary v-html="content.title"></summary>
						<div v-html="content.description" class="data"></div>
					</details>
				</div>
			</div>
		</div>
	</div>
	<MobileNav :selected="selectedId" />
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import apiClient from '@/utils/axios';

export default {
	props: ['id'],
	name: 'InfoPage',
	data() {
		return {
			loading: true,
			selectedId: 4,
			infoData: [],
			isOpen: []
		};
	},
	methods: {
	},
	setup() {
		const { t } = useI18n();
		return {
			t
		};
	},
	mounted() {
		this.isAuthenticated = keycloak.authenticated;
		if (this.isAuthenticated) {
			if(!localStorage.getItem('lang')){
				this.$router.push('/');
			}
			this.loading = true;
			apiClient.get('/' + localStorage.getItem('lang') + '/api/content/2024112210194537304?order=content.data_order')
			.then(response => {
					this.infoData = response.data;
					console.log(this.infoData);
					this.isOpen = this.infoData.map((_, index) => index === 1);
					this.loading = false;
				})
				.catch(apiError => {
					console.error('Failed to send user data:', apiError);
					this.loading = false;
				});
		} else {
			this.$router.push('/login');
		}
	}
};
</script>

<style lang="sass" scoped>

</style>